import axios from 'axios';
import * as CONSTANTS from "../../../CONSTANTS";
import './mini-dashboard.css';
import { toast } from 'react-toastify';
import { useState } from 'react';
import { FaRegTrashAlt } from "react-icons/fa";
import { Link } from 'react-router-dom';

function DashboardCatalogue({ user, selectedEvent, setUpdateAction }) {
    
  const [processing, setProcessing]                 = useState(false);

  const [selectedFiles, setSelectedFiles]           = useState([]);
  const [uploadStatus, setUploadStatus]             = useState({});
  const [successCount, setSuccessCount]             = useState(0);

  
  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
        setSelectedFiles(files);
        setUploadStatus({});
        setSuccessCount(0);
  };

  const handleUpload = async () => {
    if (!selectedEvent?._id || selectedFiles.length === 0) {
      toast.warn("Please select images and ensure the event is selected.");
      return;
    }

    let currentSuccessCount = 0;
    const statusObj = {};

    for (let i = 0; i < selectedFiles.length; i++) {
      const formData = new FormData();
      formData.append("eventId", selectedEvent._id);
      formData.append("imageCatalogue", selectedFiles[i]);

      statusObj[selectedFiles[i].name] = 'uploading';
      setUploadStatus({ ...statusObj });

      try {
        setProcessing(true)
        const response = await axios.post(`${CONSTANTS.API_URL}annivites/onvite/upload-catalogue/v1/image`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    token: 'Bearer ' + user.accessToken,
                },
            });

        if (response.status === 200) {
          statusObj[selectedFiles[i].name] = 'success';
          currentSuccessCount++;
          setUpdateAction(prev => prev + 1);
          
        } else {
          statusObj[selectedFiles[i].name] = 'error';
        }
        setProcessing(false)
      } catch (err) {
        setProcessing(false)
        statusObj[selectedFiles[i].name] = 'error';
      }

      setUploadStatus({ ...statusObj });
      setSuccessCount(currentSuccessCount);
    }

    toast.success("Upload process completed");
    setSelectedFiles([]);
   // if (setUpdateAction) setUpdateAction(true);
   
  };

  const handleDeleteThisImage = async (catalogueId) => {
    try {

        const deleteEvent = {
            "eventId" : selectedEvent._id,
            "catalogueId" : catalogueId
        }

        const response = await axios.put(`${CONSTANTS.API_URL}annivites/onvite/delete-catalogue/v1/image`, deleteEvent, {
                headers: {
                    token: 'Bearer ' + user.accessToken,
                },
            });

        
        toast.success(response.data.message);
        setUpdateAction((prev) => prev - 1);

    }catch(err){
        console.log(err);
        toast.error("Could not delete, please try again later.")
    }
  }

  return (
    <div className="dashboard-inner-box">
      <div className="header-bar">
        <h5>Proposal Images</h5>
      </div>

      <div className="list-couple">
        
            {
                selectedEvent.weddingOnviteCatalogue.length > 0 && (
                    <div className="row row-unset">
                        {
                        selectedEvent.weddingOnviteCatalogue.map((catalogue, index) => {
                            return <div className="col-md-4" key={index}>
                                     <div className="image-box">
                                        <button
                                            onClick={() => handleDeleteThisImage(catalogue.cloudinaryid)} 
                                            className="btn Bclose btn-close">
                                           
                                        </button>
                                        <img src={catalogue.url} className="img-catalogue" alt={"LoveDripp Couple " + selectedEvent.spouseA + " " + selectedEvent.spouseB} />
                                     </div>
                                   </div>} )
                        }
                    </div>
                )
            }
        
      </div>
      <div className="form-group mt-3">
        <input
          type="file"
          className="form-control"
          accept="image/*"
          multiple
          onChange={handleFileChange}
          required
        />
      </div>

      <button 
        className="btn btn-main mt-2" onClick={handleUpload}
        disabled={processing}>
        Upload Images
      </button>

      <div className="upload-status mt-3">
        {
            Object.keys(uploadStatus).length > 0 && (
            <>
                <h6>Status Summary</h6>
                <ul>
                {selectedFiles.map((file) => (
                    <li key={file.name}>
                    {file.name} - <strong>{uploadStatus[file.name]}</strong>
                    </li>
                ))}
                </ul>
                <p>✅ Success Count: <strong>{successCount}</strong></p>
            </>
            )
        }
      </div>
      
      <p className="mt-3">
        <Link to={'/couple-event/' + selectedEvent._id}>View onsite</Link>
      </p>
    </div>
  );
}

export default DashboardCatalogue